import { useRef } from 'react';

export function useCancelableRequest() {
  const controllerRef = useRef<AbortController | null>(null);

  const createRequest = () => {
    controllerRef.current = new AbortController();
    return controllerRef.current.signal;
  };

  const cancelRequest = () => {
    if (controllerRef.current) {
      controllerRef.current.abort();
      controllerRef.current = null;
    }
  };

  return { createRequest, cancelRequest };
}
